import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useVisualization = (visualizationId) => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { progressStart, progressEnd } = useActions()

  const getVisualization = async (visualizationId) => {
    const url = encodeURI(`${env.apiUrl}/visualizations/${visualizationId}`)
    const response = await securedFetch(url)
    await handleResponse(response)
    return response.json()
  }

  const query = useQuery({
    queryKey: ['visualization', visualizationId],
    queryFn: () => getVisualization(visualizationId),
    enabled: !!visualizationId,
    gcTime: 0,
    refetchOnWindowFocus: false
  })

  useEffect(() => {
    if (query.isLoading) {
      progressStart()
    } else if (query.isSuccess) {
      progressEnd()
    } else if (query.isError) {
      handleError(query.error, 'Error getting visualization')
      progressEnd()
    }
  }, [
    query.isLoading,
    query.isSuccess,
    query.isError,
    query.error,
    progressStart,
    progressEnd,
    handleError
  ])

  return {
    visualization: query.data
  }
}

export { useVisualization }
